export const LR_KVITTERA_ENDAST_RIKTADE = 'LR_KVITTERA_ENDAST_RIKTADE';
export const LR_USE_KVITTERING = 'LR_USE_KVITTERING';
export const LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS =
  'LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS';
